import 'slick-carousel';

export default () => {
  let carousel = $('.carousel');

  if (carousel.length > 0) {
    carousel.slick({
      centerMode: false,
      slidesToShow: 4,
      arrows: true,
      responsive: [
        {
          breakpoint: 820,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
}



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/carousel.js